export const skills = [
  "HTML",
  "CSS",
  "JavaScript",
  "Node.js",
  "Express.js",
  "AWS",
];
